import { createSlice } from '@reduxjs/toolkit';
import { getControlPanelListThunk } from './ControlPanelList.thunk';
import { ControlPanelListState } from './ControlPanelList.type';
import { RootState } from '../../store';

const initialState: ControlPanelListState = {
  items: [],
  isLoading: false,
};

export const controlPanelListSlice = createSlice<ControlPanelListState, any>({
  name: 'controlPanelList',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getControlPanelListThunk.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(
      getControlPanelListThunk.fulfilled,
      (state, { payload }) => {
        state.isLoading = false;
        state.items = payload.data;
      },
    );
    builder.addCase(getControlPanelListThunk.rejected, state => {
      state.isLoading = false;
    });
  },
});

export const getControlPanelList = (state: RootState) =>
  state.controlPanelList.items;

export default controlPanelListSlice.reducer;
